import Vue from "vue";
import Vuetify, {
  VRow,
  VCol,
  VTextField,
  VTooltip,
  VCheckbox,
  VSelect,
  VTextarea,
  VCard,
  VCardTitle,
  VCardSubtitle,
  VDatePicker,
  VColorPicker,
  VFileInput
} from "vuetify/lib";
import i18n from "./i18n_REMOTE";
import "@/scss/_fonts.scss";
import { Ripple, Intersect, Touch, Resize } from "vuetify/lib/directives";
import VFormText from "@/components/forms/FormText.vue";
import VFormFileViewer from "@/components/forms/FormFileViewer.vue";

Vue.use(Vuetify, {
  components: {
    VRow,
    VTooltip,
    VCol,
    VTextField,
    VCheckbox,
    VSelect,
    VTextarea,
    VCard,
    VCardTitle,
    VCardSubtitle,
    VDatePicker,
    VColorPicker,
    VFileInput,
    VFormText,
    VFormFileViewer
  },
  directives: { Ripple, Intersect, Touch, Resize }
});

export default new Vuetify({
  theme: {
    //disable: true,
    light: true,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        logo: {
          default: "/logo/logo.png",
          mobile: "/logo/logo.png"
        },
        default: {
          base: "#001227",
          lighten1: "#534741"
        },
        primary: {
          base: "#f47321",
          lighten1: "#ffa972",
          lighten2: "#ffd1b4",
          darken1: "#c95a13",
          darken2: "#8a3e0d"
        },
        secondary: {
          base: "#002f66",
          lighten1: "#044898",
          lighten2: "#2c81e5",
          darken1: "#022348",
          darken2: "#001227",
          darken3: "#022348"
        },
        accent: {
          base: "#EB1D5C"
        },
        white: "#FFFFFF",
        grey: {
          base: "#D2D2D2",
          lighten1: "#F3F4F7",
          lighten2: "#DFDDDE",
          lighten3: "#ECECEC",
          darken1: "#8D8D8D"
        },
        warning: "#ff8484"
      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  icons: {
    iconfont: "icon",
    values: {
      download: "icon-download",
      done: "icon-done",
      copy: "icon-copy",
      myLocation: "icon-my_location",
      map: "icon-world",
      schedule: "icon-calendar",
      call: "icon-callXX",
      arrowBack: "icon-arrow_left",
      arrowDownward: "icon-arrow_down",
      arrowForward: "icon-arrow_right",
      calendar: "icon-calendar",
      event: "icon-event",
      fastSearch: "icon-search",
      location: "icon-location",
      arrowTopLeft: "icon-arrow_up",
      buoni: "icon-buoni",
      cart: "icon-cart",
      chevronDown: "icon-chevron_down",
      chevronLeft: "icon-chevron_left",
      chevronRight: "icon-chevron_right",
      chevronUp: "icon-chevron_up",
      creditCard: "icon-credit_card",
      eye: "icon-eye",
      eyeOff: "icon-eye_off",
      filter: "icon-filter_list",
      heart: "icon-favorite",
      heartfull: "icon-favorite_full",
      home: "icon-home",
      indirizzi: "icon-address",
      minus: "icon-minus",
      plus: "icon-plus",
      profile: "icon-user",
      profileFull: "icon-user_black",
      search: "icon-search",
      settings: "icon-settings",
      star: "icon-star_outline",
      starFull: "icon-star_full",
      twitter: "icon-twitterXXX",
      youtube: "icon-youtubeXXX",
      instagram: "icon-instagramXXX",
      facebook: "icon-facebookXXX",
      linkedin: "icon-linkedinDDD",
      //icone standard vuetify da codificare sempre
      complete: "icon-completeXXX",
      cancel: "icon-close",
      close: "icon-close",
      delete: "icon-delete",
      clear: "icon-close",
      success: "icon-complete",
      info: "icon-info",
      warning: "icon-warning",
      error: "icon-error",
      prev: "icon-chevron_left",
      next: "icon-chevron_right",
      checkboxOff: " icon-check_box_outline_blank",
      checkboxOn: "icon-check_box",
      checkboxIndeterminate: "...",
      delimiter: "...", // for carousel
      sort: "...",
      expand: "icon-chevron_down",
      menu: "icon-menu",
      subgroup: "...",
      dropdown: "icon-chevron_down",
      radioOn: "icon-radio_button_checked",
      radioOff: "icon-radio_button_unchecked",
      edit: "icon-edit",
      print: "icon-print",
      ratingEmpty: "icon-star_outline",
      ratingFull: "icon-star_full",
      ratingHalf: "icon-star_half",
      loading: "icon-cached",
      first: "icon-first_page",
      last: "icon-last_page",
      unfold: "icon-unfold",
      file: "icon-file",
      more_vert: "icon-more_vert",
      barcode: "icon-barcode",
      barcodeScan: "icon-barcode-scan",
      tag: "icon-tag",
      percent: "icon-percent",
      logout: "icon-logout",
      bell: "icon-notifications",
      recipe: "icon-recipe",
      sms: "icon-sms",
      notifichePush: "icon-notifiche-push",
      whatsapp1: "icon-whatsapp-1",
      email1: "icon-email-1",
      recepie: "icon-recipe"
    }
  }
});
